<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { setup } from './sessionTimer.setup';

const {
  t,
  isVisibleTimer,
  isSetSessionTimeout,
  isExpiredSessionTime,
  displaySessionTime,
  isLessThanFiveMinutes,
} = setup();
</script>

<template>
  <div
    v-if="isVisibleTimer && isSetSessionTimeout"
    :class="['login-session-timer', { 'login-session-timer--highlight': isLessThanFiveMinutes }]"
  >
    <div class="login-session-timer__time">
      <ev-icon
        icon="ev-icon-time"
        size="small"
      />
      <span class="display-time">{{ displaySessionTime }}</span>
    </div>
    <base-button
      shape="border"
      class="login-session-timer__extend-btn"
      :disabled="isExpiredSessionTime"
    >
      {{ t('WORD.EXTENSION') }}
    </base-button>
  </div>
</template>

<style scoped lang="scss">
.login-session-timer {
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 12px;
  margin: 0;

  &--highlight {
    .login-session-timer__time,
    .login-session-timer__time *,
    [class*='ev-icon-'] {
      color: var(--color-red-05) !important;
    }
  }

  &__time {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    .display-time {
      width: 40px;

      @include typography('title-3');
    }
  }

  &__extend-btn {
    height: 24px !important;
  }
}
</style>
